import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { ACTIVE_BRAND_CONFIG } from '../brands/active-brand';

// Get theme colors from active brand configuration
const brandTheme = ACTIVE_BRAND_CONFIG.theme;

export const Noir = definePreset(Aura, {
  components: {
    button: {
      extends: {
        paddingX: '0.75rem',
        paddingY: '10rem',
      },
    },
  },

  semantic: {
    primary: {
      50: brandTheme.primaryColorPalette[50],
      100: brandTheme.primaryColorPalette[100],
      200: brandTheme.primaryColorPalette[200],
      300: brandTheme.primaryColorPalette[300],
      400: brandTheme.primaryColorPalette[400],
      500: brandTheme.primaryColor,
      600: brandTheme.primaryColorPalette[600],
      700: brandTheme.primaryColorPalette[700],
      800: brandTheme.primaryColorPalette[800],
      900: brandTheme.primaryColorPalette[900],
      950: brandTheme.primaryColorPalette[950],
    },
    formField: {
      paddingX: '0.65rem',
      paddingY: '0.72rem',
    },
    colorScheme: {
      light: {
        primary: {
          color: brandTheme.primaryColor,
          inverseColor: '#ffffff',
          hoverColor: brandTheme.primaryColorPalette[600],
          activeColor: brandTheme.primaryColorPalette[700],
        },
        highlight: {
          background: brandTheme.primaryColorPalette[950],
          focusBackground: brandTheme.primaryColorPalette[700],
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: brandTheme.primaryColorPalette[50],
          inverseColor: brandTheme.primaryColorPalette[950],
          hoverColor: brandTheme.primaryColorPalette[100],
          activeColor: brandTheme.primaryColorPalette[200],
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
});
